"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSupport = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
/**
 * Check whether or not the registry implements the OCI Distribution Specification.
 *
 * OCI Distribution Specification endpoint: `/v2/`
 *
 * @returns Returns a HTTP response.
 */
async function checkSupport(registryBase, username, password, options = {}, callChainObserver = { visitedUrls: [] }) {
    const result = await (0, registry_call_1.registryV2Call)(registryBase, "/", // full url path should be "/v2/" as per spec
    contentTypes.JSON, callChainObserver, username, password, options);
    // always return thruthy object, even for ECR
    return result || {};
}
exports.checkSupport = checkSupport;
//# sourceMappingURL=check-support.js.map